// ©2024 Austin App House. All rights reserved.
import Notification from '../../../components/notification';

function validateSSN(ssn) {
  // Remove any non-digit characters
  const digits = ssn.replace(/\D/g, '');

  // Must be exactly 9 digits
  if (digits.length !== 9) return false;

  const area = parseInt(digits.substring(0, 3), 10);
  const group = parseInt(digits.substring(3, 5), 10);
  const serial = parseInt(digits.substring(5, 9), 10);

  // Apply SSN format rules
  if (area === 0 || area === 666 || area >= 900) return false;
  if (group === 0) return false;
  if (serial === 0) return false;

  return true;
}


const contractorTaxInformationOnSubmit = (values) => {
  const result = {};
  if (!values.address1 || !values.state?.label || !values.city) {
    result.address1 = 'Please enter correct address';
    result.state = 'Please enter correct address';
    result.city = 'Please enter correct address';
    Notification('warning', {
      message: 'Please enter correct address',
    });
  }
  const zi = values.country?.label === 'Canada'
    ? /^([A-CEGHJ-NPRSTVXY]\d[A-CEGHJ-NPRSTV-Z][ -]?\d[A-CEGHJ-NPRSTV-Z]\d)$/
    : /(^\d{5}$)|(^\d{5}-\d{5}$)/;
  if (!zi.test(values.zipCode)) {
    result.zipCode = 'Enter valid zipcode';
    Notification('warning', {
      message: 'Enter valid zipcode',
    });
  }
  if (!values.nameAssociatedWithTIN) {
    result.nameAssociatedWithTIN = 'Please enter correct Company Name';
    Notification('warning', {
      message: 'Please enter correct Company Name',
    });
  }

  if (!values.businessName) {
    result.businessName = 'Please enter correct Business Name';
    Notification('warning', {
      message: 'Please enter correct Business Name',
    });
  }


  if(values.SSN && !values.SSN.startsWith('xxx') && !values.isEINDisplayed && !validateSSN(values.SSN)) {
    result.SSN = 'Please enter correct SSN';
    Notification('warning', {
      message: 'Please enter correct SSN',
    });
  }
  const idType = values.isEINDisplayed ? 'EIN' : 'SSN';
  if (!values[idType]) {
    result[idType] = `Please enter correct ${idType}`;
    Notification('warning', {
      message: `Please enter correct ${idType}`,
    });
  }

  if (!values.entityType) {
    result.entityType = 'Please enter correct Entity Type';
    Notification('warning', {
      message: 'Please enter correct Entity Type',
    });
  }

  if (!values.isTaxInfoCorrect) {
    result.isTaxInfoCorrect = 'Please confirm that the tax information was entered correctly';
    Notification('warning', {
      message: 'Please confirm that the tax information was entered correctly',
    });
  }

  return result;
};

export default contractorTaxInformationOnSubmit;
